import axios from "axios";
import { setViewData } from "../../../Reducer/DashboardReducer";

export class AppListFunction {
  async CretaeProduct(
    setLoading,
    body,
    setToastConfig,
    toastConfig,
    setcraeteAppShow,
    GetProduct,
    navigate,
    dispatch
  ) {
    setLoading(true);
    await axios
      .post(`${process.env.REACT_APP_API_URL}/api/v1/app`, body, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Token")}`,
        },
      })
      .then((val) => {
        setLoading(false);
        if (val?.data?.success) {
          GetProduct();
          setToastConfig({
            ...toastConfig,
            isVisible: true,
            type: "success",
            message: "Added successfully!",
          });
          setTimeout(() => {
            setToastConfig({
              ...toastConfig,
              isVisible: false,
              type: "success",
              message: "Added successfully!",
            });
          }, 1800);
          setcraeteAppShow(false);
          dispatch(setViewData(val?.data?.result));
          setTimeout(() => {
            navigate("/dashboard/app-view");
          }, 1800);
        }
      })
      .catch((err) => {
        setLoading(false);
        if (
          err?.response?.statusText === "Unauthorized" ||
          err?.response?.status === "401"
        ) {
          localStorage.clear();
          window.location.reload();
        }
        if (err?.response?.data?.success === false) {
          setToastConfig({
            ...toastConfig,
            isVisible: true,
            type: "error",
            message: "Application already exists!",
          });
          setTimeout(() => {
            setToastConfig({
              ...toastConfig,
              isVisible: false,
              type: "error",
              message: "Application already exists!",
            });
          }, 1800);
        }

        if (!err.response) {
          setToastConfig({
            ...toastConfig,
            isVisible: true,
            type: "error",
            message: "Network Error!",
          });
          setTimeout(() => {
            setToastConfig({
              ...toastConfig,
              isVisible: false,
              type: "error",
              message: "Network Error!",
            });
          }, 1800);
        }
      });
  }

  async GetProduct(
    setLoading,
    setdataDisplay,
    setdataDisplayCount,
    search,
    pagecount,
    page_limit
  ) {
    setLoading(true);
    await axios
      .get(
        `${process.env.REACT_APP_API_URL}/api/v1/app?search=${search ? search : ""
        }&page_no=${pagecount}&page_limit=${page_limit}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Token")}`,
          },
        }
      )
      .then((val) => {
        setLoading(false);
        if (val?.data?.success) {
          setdataDisplay(
            val?.data?.result?.rows?.length ? val?.data?.result?.rows : []
          );
          setdataDisplayCount(val?.data?.result?.count);
        }
      })
      .catch((err) => {
        setLoading(false);
        if (
          err?.response?.statusText === "Unauthorized" ||
          err?.response?.status === "401"
        ) {
          localStorage.clear();
          window.location.reload();
        }
      });
  }
}
